var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_vm.currentRound.steps ? _c('div', {
    staticClass: "steps-container",
    attrs: {
      "transition": "fade"
    }
  }, [_c('div', {
    staticClass: "fitb-images-container"
  }, [_c('div', {
    staticClass: "fitb-images"
  }, _vm._l(_vm.roundStepsWithImages, function (step) {
    return _c('img', {
      key: step.stepIndex,
      class: ("image-sentence-" + (step.stepIndex)),
      attrs: {
        "src": step.image
      }
    });
  }), 0)]), _c('div', {
    staticClass: "fitb-container"
  }, [_c('h2', {
    staticClass: "instructions-title",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.instructionsLabel) + "\n      ")]), _vm._l(_vm.currentRound.steps, function (step) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: step.stepIndex % 2 === 0 && _vm.progress.stepIndex >= step.stepIndex,
        expression: "step.stepIndex % 2 === 0 && progress.stepIndex >= step.stepIndex"
      }],
      key: step.stepIndex,
      class: ("sentence-" + (step.stepIndex))
    }, [_c('h3', {
      attrs: {
        "transition": "fade"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.currentRound.steps[step.stepIndex].prefix) + "\n        ")]), _c('div', {
      staticClass: "prefix-sentence"
    }, [_c('text-display-list', [_c('li', {
      attrs: {
        "transition": "fade"
      }
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": step.stepIndex
      }
    })], 1)])], 1), _c('div', {
      staticClass: "sentence-expl"
    }, [_vm.currentRound.steps[step.stepIndex + 1] ? _c('text-display-list', [_c('li', {
      attrs: {
        "transition": "fade"
      }
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": _vm.currentRound.steps[step.stepIndex + 1].answer,
        "text-step": step.stepIndex + 1
      }
    })], 1)]) : _vm._e()], 1)]);
  })], 2)]) : _vm._e(), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }